import React from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import { connect } from 'react-redux';

import * as documentActions from '../../../documents/documentsDucks';
import CategoryEntry from './CategoryEntry.jsx';
import CategoryEntity from '../../../../../shared/src/entity/CategoryEntity';

class CategoriesPanel extends React.Component {

  static propTypes = {
    /*
     * The ID of the active category.
     */
    activeCategory: React.PropTypes.shape(CategoryEntity.shape).isRequired,
    /*
     * The list of categories.
     */
    categories: React.PropTypes.arrayOf(
      React.PropTypes.shape(CategoryEntity.shape)
    ).isRequired,
    /*
     * Function to call when the user clicks on a category.
     */
    changeActiveCategory: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      displayArrow: false,
    };
  }

  onScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    this.setState({
      displayArrow: scrollLeft < (scrollWidth - clientWidth),
    });
  };

  onArrowClick = (e) => {
    e.preventDefault();
    scrollIntoViewIfNeeded(
      document.querySelector('.main-nav-content a:last-child'),
      false,
      { duration: 150 }
    );
  };

  setNavRef = (nav) => {
    this.nav = nav;
    if (nav) {
      this.setState({
        displayArrow: nav.scrollLeft < (nav.scrollWidth - nav.clientWidth),
      });
    }
  }

  render() {
    const {
      activeCategory,
      categories,
      changeActiveCategory,
    } = this.props;
    const { displayArrow } = this.state;
    return (
      <div className="main-nav">
        <div
          className={'arrow-right' + (displayArrow ? '' : ' arrow-right-hidden')}
          onClick={this.onArrowClick}
        >
          <i className="ic-arrow-right ic"/>
        </div>

        <div className="main-nav-content horizontal-native-scroll"
             id="scroller3"
             onScroll={this.onScroll}
             ref={this.setNavRef}>
          {
            categories.map(category => (
              <CategoryEntry
                key={category.id}
                activeCategory={activeCategory}
                category={category}
                onClick={changeActiveCategory}
              />
            ))
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ documents: { categories, activeCategory } }) => ({
  categories,
  activeCategory,
});

export default connect(mapStateToProps, documentActions)(CategoriesPanel);



// WEBPACK FOOTER //
// ./book/src/commons/components/book/CategoriesPanel.jsx